export function initializeToggleSectionVisibility() {
    $(".toggle-section-visibility").change(event => {
        const checkboxInput = $(event.target);
        const sectionId = checkboxInput.data("toggle-section-visibility-section-id");
        const section = $(`#${sectionId}`);
        if (checkboxInput.is(":checked")) {
            section.show();
        } else {
            section.hide();
        }
    });
}
